import { support_ticket_activity_action } from "../../../../../../utils/staticEnums";

const GROUPING_WINDOW_MS = 5 * 60 * 1000;

const HIDDEN_ACTIVITY_TYPES_BY_VIEWER = {
    client: new Set([
        support_ticket_activity_action.STATUS_CHANGED,
        support_ticket_activity_action.PRIORITY_CHANGED,
        support_ticket_activity_action.ASSIGNED,
        support_ticket_activity_action.UNASSIGNED,
    ]),
};

export const isMessageHiddenFor = (msg, viewer) => {
    const hidden = HIDDEN_ACTIVITY_TYPES_BY_VIEWER[viewer];
    if (!hidden) return false;
    return hidden.has(msg?.content?.type);
};

export const isWithinGroupingWindow = (date1, date2) => {
    return Math.abs(date1.getTime() - date2.getTime()) <= GROUPING_WINDOW_MS;
};


export const groupMessages = (messages) => {
    const groups = [];
    let currentGroup = null;

    const sortedMessages = [...messages].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
    const getGroupType = (messageType) => messageType === 'client' ? 'client' : 'other';

    sortedMessages.forEach((msg) => {
        const msgDate = new Date(msg.timestamp);
        const groupType = getGroupType(msg.message_type);
        const msgIsInternal = msg.isInternal === true;

        let shouldGroup = false;
        if (currentGroup) {
            const currentGroupType = getGroupType(currentGroup.message_type);
            const sameGroupType = groupType === currentGroupType;
            const sameSender = currentGroup.senderName === msg.senderName;
            // Never group an internal note with a public reply (or vice versa) — the
            // bubbles render differently and merging them would be misleading.
            const sameInternalState = (currentGroup.isInternal === true) === msgIsInternal;

            shouldGroup = sameGroupType && sameSender && sameInternalState && isWithinGroupingWindow(new Date(currentGroup.lastTimestamp), msgDate);
        }

        if (shouldGroup) {
            currentGroup.updates.push(msg.content);
            currentGroup.lastTimestamp = msg.timestamp;
            currentGroup.lastUpdateTime = msg.timestamp.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
        } else {
            currentGroup = {
                message_type: msg.message_type,
                isInternal: msgIsInternal,
                senderName: msg.senderName,
                timestamp: msg.timestamp,
                lastTimestamp: msg.timestamp,
                lastUpdateTime: msg.timestamp.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }),
                updates: [msg.content],
            };
            groups.push(currentGroup);
        }
    });

    return groups;
};
